import entryLevelJobsCalifornia from "./posts/entry-level-jobs-california";
import noExperienceJobsCalifornia from "./posts/no-experience-jobs-california";

const posts = [entryLevelJobsCalifornia, noExperienceJobsCalifornia];

export function getAllPosts() {
  return [...posts].sort(
    (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt),
  );
}

export function getPostBySlug(slug) {
  return posts.find((post) => post.slug === slug) ?? null;
}
